/* Generated by scripts/fontawesome/generate-inventory-icon-imports.js — do not edit. */

import { faGithub as fab_github } from "@fortawesome/free-brands-svg-icons/faGithub";
import { faSlack as fab_slack } from "@fortawesome/free-brands-svg-icons/faSlack";
import { faArrowDown as fal_arrow_down } from "@fortawesome/pro-light-svg-icons/faArrowDown";
import { faArrowUp as fal_arrow_up } from "@fortawesome/pro-light-svg-icons/faArrowUp";
import { faChevronRight as fal_chevron_right } from "@fortawesome/pro-light-svg-icons/faChevronRight";
import { faAddressCard as far_address_card } from "@fortawesome/pro-regular-svg-icons/faAddressCard";
import { faAngleLeft as far_angle_left } from "@fortawesome/pro-regular-svg-icons/faAngleLeft";
import { faAngleRight as far_angle_right } from "@fortawesome/pro-regular-svg-icons/faAngleRight";
import { faArrowsAlt as far_arrows_alt } from "@fortawesome/pro-regular-svg-icons/faArrowsAlt";
import { faBold as far_bold } from "@fortawesome/pro-regular-svg-icons/faBold";
import { faBuilding as far_building } from "@fortawesome/pro-regular-svg-icons/faBuilding";
import { faBullseye as far_bullseye } from "@fortawesome/pro-regular-svg-icons/faBullseye";
import { faBullseyeArrow as far_bullseye_arrow } from "@fortawesome/pro-regular-svg-icons/faBullseyeArrow";
import { faCalendarAlt as far_calendar_alt } from "@fortawesome/pro-regular-svg-icons/faCalendarAlt";
import { faCalendarDay as far_calendar_day } from "@fortawesome/pro-regular-svg-icons/faCalendarDay";
import { faChartColumn as far_chart_column } from "@fortawesome/pro-regular-svg-icons/faChartColumn";
import { faChartLine as far_chart_line } from "@fortawesome/pro-regular-svg-icons/faChartLine";
import { faChartPie as far_chart_pie } from "@fortawesome/pro-regular-svg-icons/faChartPie";
import { faCheckCircle as far_check_circle } from "@fortawesome/pro-regular-svg-icons/faCheckCircle";
import { faChevronDown as far_chevron_down } from "@fortawesome/pro-regular-svg-icons/faChevronDown";
import { faChevronLeft as far_chevron_left } from "@fortawesome/pro-regular-svg-icons/faChevronLeft";
import { faChevronRight as far_chevron_right } from "@fortawesome/pro-regular-svg-icons/faChevronRight";
import { faChevronUp as far_chevron_up } from "@fortawesome/pro-regular-svg-icons/faChevronUp";
import { faClipboardCheck as far_clipboard_check } from "@fortawesome/pro-regular-svg-icons/faClipboardCheck";
import { faClone as far_clone } from "@fortawesome/pro-regular-svg-icons/faClone";
import { faCog as far_cog } from "@fortawesome/pro-regular-svg-icons/faCog";
import { faCommentAltLines as far_comment_alt_lines } from "@fortawesome/pro-regular-svg-icons/faCommentAltLines";
import { faCommentDots as far_comment_dots } from "@fortawesome/pro-regular-svg-icons/faCommentDots";
import { faDatabase as far_database } from "@fortawesome/pro-regular-svg-icons/faDatabase";
import { faEdit as far_edit } from "@fortawesome/pro-regular-svg-icons/faEdit";
import { faExclamationCircle as far_exclamation_circle } from "@fortawesome/pro-regular-svg-icons/faExclamationCircle";
import { faExclamationTriangle as far_exclamation_triangle } from "@fortawesome/pro-regular-svg-icons/faExclamationTriangle";
import { faExternalLink as far_external_link } from "@fortawesome/pro-regular-svg-icons/faExternalLink";
import { faEye as far_eye } from "@fortawesome/pro-regular-svg-icons/faEye";
import { faEyeSlash as far_eye_slash } from "@fortawesome/pro-regular-svg-icons/faEyeSlash";
import { faFile as far_file } from "@fortawesome/pro-regular-svg-icons/faFile";
import { faFileImport as far_file_import } from "@fortawesome/pro-regular-svg-icons/faFileImport";
import { faGlobeAsia as far_globe_asia } from "@fortawesome/pro-regular-svg-icons/faGlobeAsia";
import { faHistory as far_history } from "@fortawesome/pro-regular-svg-icons/faHistory";
import { faInfoCircle as far_info_circle } from "@fortawesome/pro-regular-svg-icons/faInfoCircle";
import { faItalic as far_italic } from "@fortawesome/pro-regular-svg-icons/faItalic";
import { faLayerGroup as far_layer_group } from "@fortawesome/pro-regular-svg-icons/faLayerGroup";
import { faLink as far_link } from "@fortawesome/pro-regular-svg-icons/faLink";
import { faList as far_list } from "@fortawesome/pro-regular-svg-icons/faList";
import { faListOl as far_list_ol } from "@fortawesome/pro-regular-svg-icons/faListOl";
import { faListUl as far_list_ul } from "@fortawesome/pro-regular-svg-icons/faListUl";
import { faLock as far_lock } from "@fortawesome/pro-regular-svg-icons/faLock";
import { faMapLocation as far_map_location } from "@fortawesome/pro-regular-svg-icons/faMapLocation";
import { faMapMarkerAlt as far_map_marker_alt } from "@fortawesome/pro-regular-svg-icons/faMapMarkerAlt";
import { faPaperPlane as far_paper_plane } from "@fortawesome/pro-regular-svg-icons/faPaperPlane";
import { faQuestionCircle as far_question_circle } from "@fortawesome/pro-regular-svg-icons/faQuestionCircle";
import { faSearch as far_search } from "@fortawesome/pro-regular-svg-icons/faSearch";
import { faSitemap as far_sitemap } from "@fortawesome/pro-regular-svg-icons/faSitemap";
import { faSparkles as far_sparkles } from "@fortawesome/pro-regular-svg-icons/faSparkles";
import { faStopwatch as far_stopwatch } from "@fortawesome/pro-regular-svg-icons/faStopwatch";
import { faSyncAlt as far_sync_alt } from "@fortawesome/pro-regular-svg-icons/faSyncAlt";
import { faTag as far_tag } from "@fortawesome/pro-regular-svg-icons/faTag";
import { faThumbsDown as far_thumbs_down } from "@fortawesome/pro-regular-svg-icons/faThumbsDown";
import { faThumbsUp as far_thumbs_up } from "@fortawesome/pro-regular-svg-icons/faThumbsUp";
import { faThumbtack as far_thumbtack } from "@fortawesome/pro-regular-svg-icons/faThumbtack";
import { faTimes as far_times } from "@fortawesome/pro-regular-svg-icons/faTimes";
import { faTransgenderAlt as far_transgender_alt } from "@fortawesome/pro-regular-svg-icons/faTransgenderAlt";
import { faTrashAlt as far_trash_alt } from "@fortawesome/pro-regular-svg-icons/faTrashAlt";
import { faUnderline as far_underline } from "@fortawesome/pro-regular-svg-icons/faUnderline";
import { faUser as far_user } from "@fortawesome/pro-regular-svg-icons/faUser";
import { faUsers as far_users } from "@fortawesome/pro-regular-svg-icons/faUsers";
import { faUsersClass as far_users_class } from "@fortawesome/pro-regular-svg-icons/faUsersClass";
import { faVenusMars as far_venus_mars } from "@fortawesome/pro-regular-svg-icons/faVenusMars";
import { faAddressCard as fas_address_card } from "@fortawesome/pro-solid-svg-icons/faAddressCard";
import { faAngleDown as fas_angle_down } from "@fortawesome/pro-solid-svg-icons/faAngleDown";
import { faAngleLeft as fas_angle_left } from "@fortawesome/pro-solid-svg-icons/faAngleLeft";
import { faAngleRight as fas_angle_right } from "@fortawesome/pro-solid-svg-icons/faAngleRight";
import { faArrowAltLeft as fas_arrow_alt_left } from "@fortawesome/pro-solid-svg-icons/faArrowAltLeft";
import { faArrowLeft as fas_arrow_left } from "@fortawesome/pro-solid-svg-icons/faArrowLeft";
import { faArrowRight as fas_arrow_right } from "@fortawesome/pro-solid-svg-icons/faArrowRight";
import { faArrowUp as fas_arrow_up } from "@fortawesome/pro-solid-svg-icons/faArrowUp";
import { faBan as fas_ban } from "@fortawesome/pro-solid-svg-icons/faBan";
import { faBell as fas_bell } from "@fortawesome/pro-solid-svg-icons/faBell";
import { faBolt as fas_bolt } from "@fortawesome/pro-solid-svg-icons/faBolt";
import { faBrain as fas_brain } from "@fortawesome/pro-solid-svg-icons/faBrain";
import { faBuilding as fas_building } from "@fortawesome/pro-solid-svg-icons/faBuilding";
import { faBullseye as fas_bullseye } from "@fortawesome/pro-solid-svg-icons/faBullseye";
import { faBullseyeArrow as fas_bullseye_arrow } from "@fortawesome/pro-solid-svg-icons/faBullseyeArrow";
import { faBusinessTime as fas_business_time } from "@fortawesome/pro-solid-svg-icons/faBusinessTime";
import { faCalendar as fas_calendar } from "@fortawesome/pro-solid-svg-icons/faCalendar";
import { faCamera as fas_camera } from "@fortawesome/pro-solid-svg-icons/faCamera";
import { faCertificate as fas_certificate } from "@fortawesome/pro-solid-svg-icons/faCertificate";
import { faChartLine as fas_chart_line } from "@fortawesome/pro-solid-svg-icons/faChartLine";
import { faChartPie as fas_chart_pie } from "@fortawesome/pro-solid-svg-icons/faChartPie";
import { faChartPieAlt as fas_chart_pie_alt } from "@fortawesome/pro-solid-svg-icons/faChartPieAlt";
import { faCheck as fas_check } from "@fortawesome/pro-solid-svg-icons/faCheck";
import { faCheckCircle as fas_check_circle } from "@fortawesome/pro-solid-svg-icons/faCheckCircle";
import { faChevronDoubleLeft as fas_chevron_double_left } from "@fortawesome/pro-solid-svg-icons/faChevronDoubleLeft";
import { faChevronDoubleRight as fas_chevron_double_right } from "@fortawesome/pro-solid-svg-icons/faChevronDoubleRight";
import { faChevronDown as fas_chevron_down } from "@fortawesome/pro-solid-svg-icons/faChevronDown";
import { faChevronLeft as fas_chevron_left } from "@fortawesome/pro-solid-svg-icons/faChevronLeft";
import { faChevronRight as fas_chevron_right } from "@fortawesome/pro-solid-svg-icons/faChevronRight";
import { faChevronUp as fas_chevron_up } from "@fortawesome/pro-solid-svg-icons/faChevronUp";
import { faCircleNotch as fas_circle_notch } from "@fortawesome/pro-solid-svg-icons/faCircleNotch";
import { faClipboardCheck as fas_clipboard_check } from "@fortawesome/pro-solid-svg-icons/faClipboardCheck";
import { faClock as fas_clock } from "@fortawesome/pro-solid-svg-icons/faClock";
import { faCloudDownload as fas_cloud_download } from "@fortawesome/pro-solid-svg-icons/faCloudDownload";
import { faCloudUpload as fas_cloud_upload } from "@fortawesome/pro-solid-svg-icons/faCloudUpload";
import { faCloudUploadAlt as fas_cloud_upload_alt } from "@fortawesome/pro-solid-svg-icons/faCloudUploadAlt";
import { faCodeBranch as fas_code_branch } from "@fortawesome/pro-solid-svg-icons/faCodeBranch";
import { faCoffee as fas_coffee } from "@fortawesome/pro-solid-svg-icons/faCoffee";
import { faCog as fas_cog } from "@fortawesome/pro-solid-svg-icons/faCog";
import { faComment as fas_comment } from "@fortawesome/pro-solid-svg-icons/faComment";
import { faCommentAlt as fas_comment_alt } from "@fortawesome/pro-solid-svg-icons/faCommentAlt";
import { faComments as fas_comments } from "@fortawesome/pro-solid-svg-icons/faComments";
import { faCommentsAlt as fas_comments_alt } from "@fortawesome/pro-solid-svg-icons/faCommentsAlt";
import { faCopy as fas_copy } from "@fortawesome/pro-solid-svg-icons/faCopy";
import { faDatabase as fas_database } from "@fortawesome/pro-solid-svg-icons/faDatabase";
import { faDownload as fas_download } from "@fortawesome/pro-solid-svg-icons/faDownload";
import { faEdit as fas_edit } from "@fortawesome/pro-solid-svg-icons/faEdit";
import { faEnvelope as fas_envelope } from "@fortawesome/pro-solid-svg-icons/faEnvelope";
import { faExclamation as fas_exclamation } from "@fortawesome/pro-solid-svg-icons/faExclamation";
import { faExclamationCircle as fas_exclamation_circle } from "@fortawesome/pro-solid-svg-icons/faExclamationCircle";
import { faExclamationTriangle as fas_exclamation_triangle } from "@fortawesome/pro-solid-svg-icons/faExclamationTriangle";
import { faExpandAlt as fas_expand_alt } from "@fortawesome/pro-solid-svg-icons/faExpandAlt";
import { faExpandArrowsAlt as fas_expand_arrows_alt } from "@fortawesome/pro-solid-svg-icons/faExpandArrowsAlt";
import { faExternalLinkAlt as fas_external_link_alt } from "@fortawesome/pro-solid-svg-icons/faExternalLinkAlt";
import { faEye as fas_eye } from "@fortawesome/pro-solid-svg-icons/faEye";
import { faFile as fas_file } from "@fortawesome/pro-solid-svg-icons/faFile";
import { faFileAlt as fas_file_alt } from "@fortawesome/pro-solid-svg-icons/faFileAlt";
import { faFingerprint as fas_fingerprint } from "@fortawesome/pro-solid-svg-icons/faFingerprint";
import { faFlask as fas_flask } from "@fortawesome/pro-solid-svg-icons/faFlask";
import { faForward as fas_forward } from "@fortawesome/pro-solid-svg-icons/faForward";
import { faHandSparkles as fas_hand_sparkles } from "@fortawesome/pro-solid-svg-icons/faHandSparkles";
import { faHistory as fas_history } from "@fortawesome/pro-solid-svg-icons/faHistory";
import { faHome as fas_home } from "@fortawesome/pro-solid-svg-icons/faHome";
import { faHourglassHalf as fas_hourglass_half } from "@fortawesome/pro-solid-svg-icons/faHourglassHalf";
import { faImage as fas_image } from "@fortawesome/pro-solid-svg-icons/faImage";
import { faInfo as fas_info } from "@fortawesome/pro-solid-svg-icons/faInfo";
import { faInfoCircle as fas_info_circle } from "@fortawesome/pro-solid-svg-icons/faInfoCircle";
import { faLayerGroup as fas_layer_group } from "@fortawesome/pro-solid-svg-icons/faLayerGroup";
import { faLeftRight as fas_left_right } from "@fortawesome/pro-solid-svg-icons/faLeftRight";
import { faLevelUp as fas_level_up } from "@fortawesome/pro-solid-svg-icons/faLevelUp";
import { faLightbulb as fas_lightbulb } from "@fortawesome/pro-solid-svg-icons/faLightbulb";
import { faLink as fas_link } from "@fortawesome/pro-solid-svg-icons/faLink";
import { faLock as fas_lock } from "@fortawesome/pro-solid-svg-icons/faLock";
import { faLongArrowAltLeft as fas_long_arrow_alt_left } from "@fortawesome/pro-solid-svg-icons/faLongArrowAltLeft";
import { faLongArrowAltRight as fas_long_arrow_alt_right } from "@fortawesome/pro-solid-svg-icons/faLongArrowAltRight";
import { faMapMarkerAlt as fas_map_marker_alt } from "@fortawesome/pro-solid-svg-icons/faMapMarkerAlt";
import { faMemory as fas_memory } from "@fortawesome/pro-solid-svg-icons/faMemory";
import { faMicrochip as fas_microchip } from "@fortawesome/pro-solid-svg-icons/faMicrochip";
import { faMinus as fas_minus } from "@fortawesome/pro-solid-svg-icons/faMinus";
import { faMobileAlt as fas_mobile_alt } from "@fortawesome/pro-solid-svg-icons/faMobileAlt";
import { faMousePointer as fas_mouse_pointer } from "@fortawesome/pro-solid-svg-icons/faMousePointer";
import { faPalette as fas_palette } from "@fortawesome/pro-solid-svg-icons/faPalette";
import { faPaperPlane as fas_paper_plane } from "@fortawesome/pro-solid-svg-icons/faPaperPlane";
import { faPause as fas_pause } from "@fortawesome/pro-solid-svg-icons/faPause";
import { faPen as fas_pen } from "@fortawesome/pro-solid-svg-icons/faPen";
import { faPencil as fas_pencil } from "@fortawesome/pro-solid-svg-icons/faPencil";
import { faPhone as fas_phone } from "@fortawesome/pro-solid-svg-icons/faPhone";
import { faPlay as fas_play } from "@fortawesome/pro-solid-svg-icons/faPlay";
import { faPlayCircle as fas_play_circle } from "@fortawesome/pro-solid-svg-icons/faPlayCircle";
import { faPlug as fas_plug } from "@fortawesome/pro-solid-svg-icons/faPlug";
import { faPlus as fas_plus } from "@fortawesome/pro-solid-svg-icons/faPlus";
import { faPoll as fas_poll } from "@fortawesome/pro-solid-svg-icons/faPoll";
import { faProjectDiagram as fas_project_diagram } from "@fortawesome/pro-solid-svg-icons/faProjectDiagram";
import { faQuestion as fas_question } from "@fortawesome/pro-solid-svg-icons/faQuestion";
import { faQuestionCircle as fas_question_circle } from "@fortawesome/pro-solid-svg-icons/faQuestionCircle";
import { faRedo as fas_redo } from "@fortawesome/pro-solid-svg-icons/faRedo";
import { faRobot as fas_robot } from "@fortawesome/pro-solid-svg-icons/faRobot";
import { faRocket as fas_rocket } from "@fortawesome/pro-solid-svg-icons/faRocket";
import { faSave as fas_save } from "@fortawesome/pro-solid-svg-icons/faSave";
import { faSearch as fas_search } from "@fortawesome/pro-solid-svg-icons/faSearch";
import { faSearchDollar as fas_search_dollar } from "@fortawesome/pro-solid-svg-icons/faSearchDollar";
import { faServer as fas_server } from "@fortawesome/pro-solid-svg-icons/faServer";
import { faShareAlt as fas_share_alt } from "@fortawesome/pro-solid-svg-icons/faShareAlt";
import { faShareSquare as fas_share_square } from "@fortawesome/pro-solid-svg-icons/faShareSquare";
import { faSignOutAlt as fas_sign_out_alt } from "@fortawesome/pro-solid-svg-icons/faSignOutAlt";
import { faSitemap as fas_sitemap } from "@fortawesome/pro-solid-svg-icons/faSitemap";
import { faSparkles as fas_sparkles } from "@fortawesome/pro-solid-svg-icons/faSparkles";
import { faSpinner as fas_spinner } from "@fortawesome/pro-solid-svg-icons/faSpinner";
import { faStar as fas_star } from "@fortawesome/pro-solid-svg-icons/faStar";
import { faStop as fas_stop } from "@fortawesome/pro-solid-svg-icons/faStop";
import { faSync as fas_sync } from "@fortawesome/pro-solid-svg-icons/faSync";
import { faTag as fas_tag } from "@fortawesome/pro-solid-svg-icons/faTag";
import { faThumbtack as fas_thumbtack } from "@fortawesome/pro-solid-svg-icons/faThumbtack";
import { faTimes as fas_times } from "@fortawesome/pro-solid-svg-icons/faTimes";
import { faTimesCircle as fas_times_circle } from "@fortawesome/pro-solid-svg-icons/faTimesCircle";
import { faTrash as fas_trash } from "@fortawesome/pro-solid-svg-icons/faTrash";
import { faUndoAlt as fas_undo_alt } from "@fortawesome/pro-solid-svg-icons/faUndoAlt";
import { faUpload as fas_upload } from "@fortawesome/pro-solid-svg-icons/faUpload";
import { faUser as fas_user } from "@fortawesome/pro-solid-svg-icons/faUser";
import { faUserEdit as fas_user_edit } from "@fortawesome/pro-solid-svg-icons/faUserEdit";
import { faUserFriends as fas_user_friends } from "@fortawesome/pro-solid-svg-icons/faUserFriends";
import { faUserMinus as fas_user_minus } from "@fortawesome/pro-solid-svg-icons/faUserMinus";
import { faUserPlus as fas_user_plus } from "@fortawesome/pro-solid-svg-icons/faUserPlus";
import { faUserSecret as fas_user_secret } from "@fortawesome/pro-solid-svg-icons/faUserSecret";
import { faUserTimes as fas_user_times } from "@fortawesome/pro-solid-svg-icons/faUserTimes";
import { faUsers as fas_users } from "@fortawesome/pro-solid-svg-icons/faUsers";
import { faVial as fas_vial } from "@fortawesome/pro-solid-svg-icons/faVial";
import { faWrench as fas_wrench } from "@fortawesome/pro-solid-svg-icons/faWrench";

export default [
  fab_github,
  fab_slack,
  fal_arrow_down,
  fal_arrow_up,
  fal_chevron_right,
  far_address_card,
  far_angle_left,
  far_angle_right,
  far_arrows_alt,
  far_bold,
  far_building,
  far_bullseye,
  far_bullseye_arrow,
  far_calendar_alt,
  far_calendar_day,
  far_chart_column,
  far_chart_line,
  far_chart_pie,
  far_check_circle,
  far_chevron_down,
  far_chevron_left,
  far_chevron_right,
  far_chevron_up,
  far_clipboard_check,
  far_clone,
  far_cog,
  far_comment_alt_lines,
  far_comment_dots,
  far_database,
  far_edit,
  far_exclamation_circle,
  far_exclamation_triangle,
  far_external_link,
  far_eye,
  far_eye_slash,
  far_file,
  far_file_import,
  far_globe_asia,
  far_history,
  far_info_circle,
  far_italic,
  far_layer_group,
  far_link,
  far_list,
  far_list_ol,
  far_list_ul,
  far_lock,
  far_map_location,
  far_map_marker_alt,
  far_paper_plane,
  far_question_circle,
  far_search,
  far_sitemap,
  far_sparkles,
  far_stopwatch,
  far_sync_alt,
  far_tag,
  far_thumbs_down,
  far_thumbs_up,
  far_thumbtack,
  far_times,
  far_transgender_alt,
  far_trash_alt,
  far_underline,
  far_user,
  far_users,
  far_users_class,
  far_venus_mars,
  fas_address_card,
  fas_angle_down,
  fas_angle_left,
  fas_angle_right,
  fas_arrow_alt_left,
  fas_arrow_left,
  fas_arrow_right,
  fas_arrow_up,
  fas_ban,
  fas_bell,
  fas_bolt,
  fas_brain,
  fas_building,
  fas_bullseye,
  fas_bullseye_arrow,
  fas_business_time,
  fas_calendar,
  fas_camera,
  fas_certificate,
  fas_chart_line,
  fas_chart_pie,
  fas_chart_pie_alt,
  fas_check,
  fas_check_circle,
  fas_chevron_double_left,
  fas_chevron_double_right,
  fas_chevron_down,
  fas_chevron_left,
  fas_chevron_right,
  fas_chevron_up,
  fas_circle_notch,
  fas_clipboard_check,
  fas_clock,
  fas_cloud_download,
  fas_cloud_upload,
  fas_cloud_upload_alt,
  fas_code_branch,
  fas_coffee,
  fas_cog,
  fas_comment,
  fas_comment_alt,
  fas_comments,
  fas_comments_alt,
  fas_copy,
  fas_database,
  fas_download,
  fas_edit,
  fas_envelope,
  fas_exclamation,
  fas_exclamation_circle,
  fas_exclamation_triangle,
  fas_expand_alt,
  fas_expand_arrows_alt,
  fas_external_link_alt,
  fas_eye,
  fas_file,
  fas_file_alt,
  fas_fingerprint,
  fas_flask,
  fas_forward,
  fas_hand_sparkles,
  fas_history,
  fas_home,
  fas_hourglass_half,
  fas_image,
  fas_info,
  fas_info_circle,
  fas_layer_group,
  fas_left_right,
  fas_level_up,
  fas_lightbulb,
  fas_link,
  fas_lock,
  fas_long_arrow_alt_left,
  fas_long_arrow_alt_right,
  fas_map_marker_alt,
  fas_memory,
  fas_microchip,
  fas_minus,
  fas_mobile_alt,
  fas_mouse_pointer,
  fas_palette,
  fas_paper_plane,
  fas_pause,
  fas_pen,
  fas_pencil,
  fas_phone,
  fas_play,
  fas_play_circle,
  fas_plug,
  fas_plus,
  fas_poll,
  fas_project_diagram,
  fas_question,
  fas_question_circle,
  fas_redo,
  fas_robot,
  fas_rocket,
  fas_save,
  fas_search,
  fas_search_dollar,
  fas_server,
  fas_share_alt,
  fas_share_square,
  fas_sign_out_alt,
  fas_sitemap,
  fas_sparkles,
  fas_spinner,
  fas_star,
  fas_stop,
  fas_sync,
  fas_tag,
  fas_thumbtack,
  fas_times,
  fas_times_circle,
  fas_trash,
  fas_undo_alt,
  fas_upload,
  fas_user,
  fas_user_edit,
  fas_user_friends,
  fas_user_minus,
  fas_user_plus,
  fas_user_secret,
  fas_user_times,
  fas_users,
  fas_vial,
  fas_wrench,
];
